import {
  DurationType,
  PartDurationType,
  PartInput,
  PartType,
  ReservationPartInput,
} from "../../GeneratedGraphQL";
import { Interval, Service } from "../../AppDataProvider/types";

import { addMinutes } from "date-fns";

export function getAvailabilityPartsInput(
  parts?: Service["parts"],
): PartInput[] {
  return (parts ?? []).reduce<PartInput[]>((acc, part) => {
    if (part) {
      const duration =
        part.durationType === PartDurationType.Hours
          ? part.duration * 60
          : part.duration;
      const { type } = part;
      acc.push({ duration, type });
    }
    return acc;
  }, []);
}

type GetReservationPartsOptions = {
  parts?: Service["parts"];
  selectedInterval: Interval;
};

export function getReservationPartsInput({
  parts,
  selectedInterval,
}: GetReservationPartsOptions): ReservationPartInput[] {
  // Create a single block part for whole interval if there's no non-null parts
  if (!parts?.filter((part) => !!part).length)
    return [
      {
        end: selectedInterval.end,
        start: selectedInterval.start,
        type: DurationType.Block,
      },
    ];

  // Otherwise, calculate start/end times for each part
  return parts.reduce<ReservationPartInput[]>((acc, part) => {
    if (part) {
      const { duration, durationType, label, type: partType } = part;

      const endOfPreviousPart = acc[acc.length - 1]?.end;
      const start = endOfPreviousPart ?? selectedInterval.start;

      const minutes =
        durationType === PartDurationType.Hours ? duration * 60 : duration;
      const endDate = addMinutes(new Date(start), minutes);
      const end = endDate.toISOString();

      const type =
        partType === PartType.Block ? DurationType.Block : DurationType.Free;

      acc.push({ end, label, start, type });
    }

    return acc;
  }, []);
}
